export default {
  title: 'Questions de sécurité',
  informationsLabel: 'Vos réponses doivent contenir de 4 à 25 caractères, être composées de chiffres ou de lettres, sans accent ni caractères spéciaux.',
};
